module.exports = __webpack_public_path__ + "img/1.15281f6d.jpg";